import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const steps = [
  ["01", "Kurz anrufen oder schreiben", "Sie schildern uns, was geräumt, transportiert oder umgezogen werden soll."],
  ["02", "Umfang gemeinsam klären", "Wir besprechen die Situation, den gewünschten Termin und die nächsten Schritte."],
  ["03", "Individuelles Angebot erhalten", "Auf Grundlage Ihrer Angaben entsteht ein Angebot, das zu Ihrem Auftrag passt."],
  ["04", "Auftrag zuverlässig umsetzen", "Wir arbeiten strukturiert und stimmen die Übergabe mit Ihnen ab."],
];

export default function ProcessSection() {
  return (
    <section className="section process-section" id="ablauf" data-testid="protocol-timeline-container">
      <div className="container">
        <Reveal className="section-heading-row process-heading">
          <div className="section-index">03 / 05</div>
          <div>
            <span className="eyebrow">Der Ablauf</span>
            <h2 className="section-title">Klar besprochen.<br /><em>Sauber umgesetzt.</em></h2>
            <p className="section-lead">Keine komplizierten Wege. Ein direkter Kontakt, ein gemeinsames Verständnis und ein Ablauf, der zu Ihrem Auftrag passt.</p>
          </div>
        </Reveal>
        <div className="process-list">
          {steps.map(([number, title, copy], index) => (
            <Reveal key={number} className="process-step" delay={index * 80}>
              <article data-testid={`protocol-step-${number}`}>
                <span className="process-number">{number}</span>
                <div className="process-copy"><h3>{title}</h3><p>{copy}</p></div>
                <ArrowRight className="process-arrow" size={20} strokeWidth={1.4} />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
